import { useEffect } from 'react';

const useScript = (url, async = false, defer = false) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = url;
    script.async = async;
    script.defer = defer

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, [url]);
};

export default useScript;